import ComponentWithSocket from '../../lib/component';
import { Component } from 'vue-property-decorator';

import template from './prebid.vue';

import * as Store from './../../store';

interface BidData {
    _id: string;
    price: any;
    theUser: any;
    theLot: any;
    theAuction: any;
    verification?: any;
    message?: any;
    commission: number;
}

@Component({
    mixins: [template],
})
export default class PreBid extends ComponentWithSocket {
    data: BidData = {
        _id: '',
        price: '',
        theLot: {},
        theUser: {},
        theAuction: {},
        verification: undefined,
        message: '',
        commission: 0
    };

    constructor() {
        super();

        this.wsListener.onGet('auth.profile', (success: boolean, data: any) => {
            if (success) {
                this.data.theUser = data.profile;
                this.data.verification = data.verification;
                Store.commitLoaderVisibility(this.$store, false);
            }
        });

        this.wsListener.onGet('lots.find', (success: boolean, data: any) => {
            if (success) {
                this.data.theLot = data;
                this.wsListener.sendGet('auctions.find', {
                    _id: this.data.theLot.auction,
                });
            }
        });

        this.wsListener.onGet('lots.commission', (success: boolean, data: any) => {
            if (success) {
                this.data.commission = data;
            }
        });

        this.wsListener.onGet(
            'auctions.find',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.theAuction = data;
                }
            },
        );

        this.wsListener.onPost(
            'lots.pre.bid',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.message = {
                        type: 'success',
                        text: 'Oferta a fost înregistrată.',
                    };
                } else {
                    this.data.message = { type: 'error', text: data };
                }

                this.data.price = '';
            },
        );

        this.wsListener.onPost(
            'lots.post.bid',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.message = {
                        type: 'success',
                        text: 'Oferta a fost înregistrată.',
                    };
                } else {
                    this.data.message = { type: 'error', text: data };
                }

                this.data.price = '';
            },
        );

        try {
            // @ts-ignore
            window.fbq('track', 'InitiateCheckout');
        } catch (err) {
            console.error(err);
        }
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        this.wsListener.sendGet('auth.profile');
        this.wsListener.sendGet('lots.find', {
            _id: this.data._id,
            populateAuthor: true,
        });
        this.wsListener.sendGet('lots.commission');
    }

    created() {
        this.data._id = this.$root.$route.params.id;
    }

    postPreBid(e: any) {
        e.preventDefault();

        if (this.data.message && this.data.message.type == 'success') {
            return;
        }

        this.wsListener.sendPost('lots.pre.bid', {
            lot: this.data.theLot._id,
            price: this.data.price,
        });

        try {
            // @ts-ignore
            window.fbq('track', 'Purchase', {
                value: this.data.price,
                currency: 'EUR',
            });
        } catch (err) {
            console.error(err);
        }
    }

    postPostBid(e: any) {
        e.preventDefault();

        if (this.data.message && this.data.message.type == 'success') {
            return;
        }

        this.wsListener.sendPost('lots.post.bid', {
            lot: this.data.theLot._id,
            price: this.data.theLot.startingPrice,
        });

        try {
            // @ts-ignore
            window.fbq('track', 'Purchase', {
                value: this.data.price,
                currency: 'EUR',
            });
        } catch (err) {
            console.error(err);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/prebid/index.ts